import type { ReactNode } from 'react';
import { Button } from '@monksflow/monks-ui';
import { ArrowLeft } from 'lucide-react';

import { StaggerItem } from '@/shared/ui/animations';
import { useTranslation } from 'react-i18next';

interface DetailHeaderProps {
  title: string;
  subtitle?: string;
  icon?: ReactNode;
  onBack?: () => void;
  actions?: ReactNode;
}

export const DetailHeader = ({ title, subtitle, icon, onBack, actions }: DetailHeaderProps) => {
  const { t } = useTranslation('common');
  return (
    <header className="flex items-center justify-between rounded-lg bg-card p-6">
      <StaggerItem index={0}>
        <div className="flex items-center gap-4">
          {onBack && (
            <Button
              type="button"
              variant="ghost"
              size="icon-sm"
              onClick={onBack}
              className="text-muted-foreground hover:text-foreground"
              aria-label={t('components.detailHeader.goBack')}
            >
              <ArrowLeft />
            </Button>
          )}
          {icon}
          <div>
            <h1 className="text-heading-lg font-medium">{title}</h1>
            {subtitle && <p className="text-sm text-muted-foreground">{subtitle}</p>}
          </div>
        </div>
      </StaggerItem>
      {actions && (
        <StaggerItem index={1}>
          <div className="flex items-center gap-2">{actions}</div>
        </StaggerItem>
      )}
    </header>
  );
};
